export default __webpack_public_path__ + "static/media/video-advertise2.cc42ea0b.png";